"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const signature_1 = require("../signature");
class CountNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'count')
            return new CountNode();
        return null;
    }
    constructor() {
        super('Count node');
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature() {
        if (!this.incoming[0])
            return null;
        let signature = new signature_1.default();
        signature.grains = [];
        signature.columns = [new signature_1.ColumnSignature('count', this.id)];
        return signature;
    }
    validate(datasetRepo) {
        if (!this.incoming[0])
            return false;
        return this.incoming[0].validate(datasetRepo);
    }
    serialize() {
        return super.serialize({ type: 'count' });
    }
}
exports.default = CountNode;
